import { SETNAVIGATIONTITLE } from '../../type.js';
export default {
  namespaced: true,
  // state 定义了应用状态的数据结构，同样可以在这里设置默认的初始状态。
  state: {
    isCollapse: false, // 左侧面板折叠
    navigationArr: [] // 当前位置
  },
  // actions 即是定义提交触发更改信息的描述，在数据获取完成后会调用store.commit()来调用更改 Store 中的状态。可以在组件中使用dispatch来发出 Actions。
  actions: {
    updateCollapse ({ commit }, val) {
      commit('newIsCollapse', val);
    },
    [SETNAVIGATIONTITLE] ({commit}, val) {
      commit(SETNAVIGATIONTITLE, val);
    }
  },
  // 调用 mutations 是唯一允许更新应用状态的地方。
  mutations: {
    newIsCollapse (state, val) {
      state.isCollapse = val;
    },
    [SETNAVIGATIONTITLE] (state, val) {
      state.navigationArr = val;
    }
  }
};



// WEBPACK FOOTER //
// ./src/vuex/modules/nav/index.js